import { Button, Typography } from "@plum-xoxo/admin-dsm";
import React from "react";
import { Link } from "react-router-dom";
import { app_path } from "config";

const EmptyReportBtn = ({ title, tableData, kyb_status }) => {
  let link = "";
  let btnTitle = "";
  if (kyb_status === 0 || kyb_status === 3) {
    link = "accounts/platform-preferences/";
    btnTitle = "Verify Business Details";
  } else if (title === "payments" || title === "redemption history") {
    link = "recharge/";
    btnTitle = "Add Funds";
  } else if (title === "xoxo rewards api") {
    link = "generate-brand-voucher/";
    btnTitle = "Send Brand Vouchers";
  } else {
    link = title.replace("reward ", "").replace(" ", "-");
    btnTitle = `Send ${tableData?.title}`;
  }
  return kyb_status === 1 ? (
    <Typography component="span" color="warning" shade="c02">
      Business verification is being processed.
    </Typography>
  ) : (
    <Link to={`/${app_path}/${link}`}>
      <Button>{btnTitle}</Button>
    </Link>
  );
};

export default EmptyReportBtn;
